/* eslint-disable */
import React, { Component } from 'react';
import App_data from '../../config/App_data';
import FD from '../../RestAPI/fetchData';
import language from '../../../assets/languages/language';
import { Tooltip, Col, Row } from 'reactstrap';
import ValidateSaveReportIcon from '../../Common/ValidateSaveReportIcon';
import { renderHTMLContent } from '../../../common/function';
import ViewQuestion from '../../../Components-2025/QuestionBank/ViewQuestion';
import { messages } from '../../../common/messages';
import CustomButton from '../../../common/CustomButton';
import { aiTutorExamYear, aiTutorPageUrl, aiTutorStem, clearAiTutorContext, isAiTutorAvailable, AI_TRIGGER_BTN_STYLE } from '../../../common/aiTutorContext';
import AppRoutes from '../../config/AppRoutes';
import { nextAwareRoute } from '../../../common/cfa1NextRoutes';

class BeginQuiz extends Component {
  constructor(props) {
    super(props);
    const initialTimerStop = JSON.parse(localStorage.getItem('timer_stop')) || false; 
    this.state = {
      successAlert: false,
      token: '',
      idname: '',
      quiz_id: this.props.params.quiz_id,
      offset: this.props.params.offset ? parseInt(this.props.params.offset, 10) : 0,
      all_question_id: [],
      timer_value: '',
      include_timer: '',
      user_time_value: '',
      first_question_id: '',
      display_question: {},
      save_text: `${language.LC().SAVE_QUESTION}`,
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      flagCSS: 'fa fa-flag-o mark-action-btn',
      count: 0,
      isValidToken: false,
      choice_a: 'answer_box',
      choice_b: 'answer_box',
      choice_c: 'answer_box',
      result_block: 'card hide_block',
      report_block: 'card hide_block',
      correctChoice: '',
      isAnswered: false,
      selectedChoice: '',
      result: '',
      textColor: 'card-header',
      records: '',
      savedQuestion: false,
      comment: 'card-block',
      flashcard: 'card-block',
      comment_data: '',
      flash_data: [],
      flash_form: 'col-md-12 display_block',
      comment_arrow: '',
      flash_card_arrow: '',
      flash_class: 'edit_right_padding',
      count_end_message: '',
      isTimerStopped: initialTimerStop, 
      timer_tag: `${language.LC().STOP}`,
      timer_display: 'card-block', 
      rating: 0,
      rated: false,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      validated: false, 
      comment_update: 'hide_block',
      comment_save: 'btn btn-primary active pointer_class',
      comment_update_id: '',
      next_block: '',
      previ_block: '',
      already_answered_status: '',
      display_loader: 'show_block',
      tooltips: [
        {
          placement: `${language.LC().COMMENT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().REPORT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().FLASHCARD_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
      ],
      isFlashCardVisible: false,
      isCommentVisible: false,
    };
    this.timer = null;
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    clearAiTutorContext(); // leaving the quiz → drop its AI-tutor context
  }

  hasTimerFeatureEnabled = () => {
    const { include_timer, timer_value } = this.state;
    return !!include_timer || (timer_value && parseInt(timer_value, 10) > 0);
  }

  reverseTimerHandler = () => {
    this.setState((prevState) => {
      const countValue = Number(prevState.count);

      if (!Number.isFinite(countValue) || countValue <= 0) {
        clearInterval(this.timer);
        localStorage.setItem('timer_stop', JSON.stringify(true));
        return { isTimerStopped: true };
      }

      const remainingTime = countValue - 1;
      
      // Only make API call if timer is not stopped
      if (!prevState.isTimerStopped) {
        const insert_time = {
          token: prevState.token,
          idname: prevState.idname,
          quiz_id: prevState.quiz_id,
          user_time_value: remainingTime,
        };
        FD.callAPI(`${App_data.backend_api}/cfa_2025_quizes/insertTimer`, insert_time);
      }

      return { count: remainingTime };
    });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    if (parseInt(this.state.offset) === 0) this.setState({ previ_block: 'card hide_block' });
    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      }, () => this.fetchQuizData());
    } else {
      this.setState({ display_loader: 'hide_block', already_answered_status: messages.USER_SESSION_NOT_FOUND });
    }
  }

  fetchQuizData = () => {
    const { token, idname, quiz_id, offset } = this.state;
    const data = { idname, token, quiz_id };
    FD.callAPI(`${App_data.backend_api}/cfa_2025_quizes/getQuize`, data).then((resp) => {
      if (resp.success) {
        const quizData = JSON.parse(resp.singlequiz);
        const questions = Object.values(quizData.all_questions);
        const currentQuestionId = questions[offset];
        const timerValue = Number(resp.timer_value) || 0;
        const hasUserTimeValue = resp.user_time_value !== undefined && resp.user_time_value !== null;
        const userTimeValue = hasUserTimeValue ? Number(resp.user_time_value) : timerValue;
        const initialTimerValue = (userTimeValue > 0) ? userTimeValue : timerValue;

        this.setState({
          user_time_value: userTimeValue,
          count: initialTimerValue > 0 ? initialTimerValue : 0,
          timer_value: timerValue,
          all_question_id: questions,
          include_timer: resp.include_timer,
          first_question_id: currentQuestionId,
        }, () => {
          if (questions.length - 1 === offset) this.setState({ next_block: 'card hide_block' });
          if (currentQuestionId) this.fetchQuestionDetails(currentQuestionId);
          else this.setState({display_loader: 'hide_block', already_answered_status: messages.QUESTION_NOT_FOUND});
        });
      } else {
        this.setState({ display_loader: 'hide_block', already_answered_status: messages.QUIZ_DATA_FETCH_ERROR });
      }
    }).catch(error => {
        this.setState({ display_loader: 'hide_block', already_answered_status: error.message || 'Failed to connect to server' });
    });
  }

  // Helper to extract answer/choice from API response for DRY
  getUserAnswerState(questionResponse, correctAnswer, questionsbyid) {
    const selectedChoice = questionResponse.selected_choice || '';
    const isRightChoice = questionResponse.answer || '';
    const hasAnswerStatus = questionResponse.id || '';
    let showAnswer = false;
    let selected = '';
    if (selectedChoice) {
      selected = selectedChoice;
      showAnswer = true;
    } else if (hasAnswerStatus) {
      if (isRightChoice === 1) {
        selected = correctAnswer;
        showAnswer = true;
      } else if (!isRightChoice) {
        // Pick any incorrect choice (not the correct one)
        const choices = Object.keys(questionsbyid)
          .filter(key => key.startsWith('choice') && key !== correctAnswer);
        selected = choices.length > 0 ? choices[0] : '';
        showAnswer = true;
      }
    }
    return { selected, showAnswer };
  }

  // ── AI Tutor "Explain my answer" (quiz surface) ──────────────────────────────────
  // Mirrors QuestionBank/QuestionView: the full item (question + chosen/correct choice
  // TEXTS) rides inside the published context once answered, so the sidebar chat and a
  // typed "explain my answer" are grounded exactly like the on-card ✦ button.
  buildAiItem = (q, selectedChoice) => ({
    questionId: q.id,
    stem: q.question,
    chosen: selectedChoice,
    chosen_text: aiTutorStem(q[selectedChoice], 300),
    correct: q.right_choice,
    correct_text: aiTutorStem(q[q.right_choice], 300),
    topic: q.name_2025 || q.name,
  });

  buildAiContext = (q, answer) => {
    // answer state passed explicitly by callers inside setState batches (this.state is
    // stale there); falls back to current state for direct calls.
    const a = answer || { selectedChoice: this.state.selectedChoice, showAnswer: this.state.isAnswered };
    const readingName = (q && (q.name_2025 || q.name)) || '';
    const context = {
      exam: 'CFA1',
      exam_year: aiTutorExamYear(),
      page_url: aiTutorPageUrl(),
      page_type: 'quiz',
      content_id: q && q.id,
      title: q && readingName ? `${readingName} (Q. ${q.id})` : 'CFA Level I',
      reading: readingName,
      chapter: (q && q.chapterName) || '', // resolved server-side in getQuestionsbyid
      // the actual question text — the strongest KB grounding signal
      stem: q && q.question
        ? String(q.question).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 400)
        : '',
    };
    if (q && a.showAnswer && a.selectedChoice) {
      context.item = this.buildAiItem(q, a.selectedChoice);
    }
    return context;
  };

  dispatchAiContext = (q, answer) => {
    if (!q || !q.id) return;
    try {
      const context = this.buildAiContext(q, answer);
      window.__aiTutorContext = context; // read by the sidebar-opened tutor (timing-proof)
      window.dispatchEvent(new CustomEvent('aitutor:context', { detail: { context } }));
    } catch (e) { /* noop */ }
  };

  explainMyAnswer = () => {
    const q = this.state.display_question;
    const { selectedChoice } = this.state;
    if (!q || !q.id) return;
    try {
      window.dispatchEvent(new CustomEvent('aitutor:explain', { detail: {
        context: this.buildAiContext(q, { selectedChoice, showAnswer: true }),
        item: this.buildAiItem(q, selectedChoice),
        message: 'Explain my answer',
      } }));
    } catch (e) { /* noop */ }
  };

  fetchQuestionDetails = (question_id) => {
    const { token, idname, quiz_id } = this.state;
    const questionDataPayload = { token, idname, question_id };
    FD.callAPI(`${App_data.backend_api}/question_bank_2025/getQuestionsbyid`, questionDataPayload).then((questionData) => {
      if (questionData.success) {
        this.setState({
          display_question: questionData.questionsbyid,
          correctChoice: questionData.questionsbyid.right_choice,
        });
        const checkAnsweredData = { token, idname, quiz_id, question_id };
        FD.callAPI(`${App_data.backend_api}/cfa_2025_quizes/checkAnswered`, checkAnsweredData).then(
          (answeredResp) => {
            const questionResponse = answeredResp.question_recived || {};
            const correctAnswer = questionData.questionsbyid.right_choice;
            // Use helper for DRY
            const { selected, showAnswer } = this.getUserAnswerState(questionResponse, correctAnswer, questionData.questionsbyid);
            this.setState({
              selectedChoice: selected,
              isAnswered: !!selected,
              validated: !!selected,
              result_block: selected ? 'card show_block' : 'card hide_block',
              textColor: selected === correctAnswer ? 'card-header text_success' : 'card-header text_failure',
              result: selected === correctAnswer ? messages.CORRECT : messages.INCORRECT,
              display_loader: 'hide_block',
            });
            // Publish AI-tutor context for this question (fresh on every load / prev-next) —
            // explicit answer state because setState above is async.
            this.dispatchAiContext(questionData.questionsbyid, { selectedChoice: selected, showAnswer: !!selected });
            // Timer logic remains unchanged
            const timerFeatureActive = this.hasTimerFeatureEnabled();
            if (selected) { 
                if (this.timer) clearInterval(this.timer);
                this.setState({ isTimerStopped: true });
                localStorage.setItem('timer_stop', JSON.stringify(true));
            } else { 
                if (timerFeatureActive && this.state.count > 0) {
                    clearInterval(this.timer); 
                    this.timer = setInterval(this.reverseTimerHandler.bind(this), 1000);
                    this.setState({ isTimerStopped: false });
                    localStorage.setItem('timer_stop', JSON.stringify(false)); 
                } else { 
                    if (this.timer) clearInterval(this.timer);
                    this.setState({ isTimerStopped: true });
                    if (!this.state.count_end_message || (timerFeatureActive && this.state.count <= 0 && !this.state.count_end_message) ) {
                         localStorage.setItem('timer_stop', JSON.stringify(true));
                    }
                }
            }
            // After setting question details, check if the question is bookmarked
            const favParams = {
              token: this.state.token,
              question_id: question_id,
              idname: this.state.idname,
            };
            FD.callAPI(`${App_data.backend_api}/question_bank_2025/getFavQuestions`, favParams).then(
              response => {
                const isSaved = response.success;
              
                this.setState({
                  save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
                  bookmarkCSS: isSaved
                    ? 'fa fa-bookmark mark-action-btn-bookmark'
                    : 'fa fa-bookmark-o mark-action-btn-bookmark',
                  bookmarkColor: isSaved ? 'rgb(54, 141, 84)' : '',
                  save_text: isSaved
                    ? language.LC().Question_Saved
                    : language.LC().SAVE_QUESTION,
                });              
              }
            );
          }
        ).catch(error => {
            this.setState({ display_loader: 'hide_block', already_answered_status: messages.CHECK_ANSWERED_ERROR });
        });
      } else {
         this.setState({ display_loader: 'hide_block', already_answered_status: messages.QUESTION_DETAILS_ERROR });
      }
    }).catch(error => {
        this.setState({ display_loader: 'hide_block', already_answered_status: messages.QUESTION_API_ERROR });
    });
  }

  handleAnswerSelect = (answerArray) => {
    const answer = answerArray[0];
    if (!this.state.isAnswered) { 
      if (this.hasTimerFeatureEnabled() && !this.state.isTimerStopped) { 
        clearInterval(this.timer);
        this.setState({
          isTimerStopped: true,
        });
        localStorage.setItem('timer_stop', JSON.stringify(true)); 
      }
      this.setState({ selectedChoice: answer }); 
    }
  };

  handleResultEvaluation = (questionItem) => {
    const { selectedChoice, isAnswered, token, idname, quiz_id, all_question_id, offset, validated } = this.state;
    if (selectedChoice && !isAnswered) { 
      if (this.hasTimerFeatureEnabled() && !this.state.isTimerStopped) { 
        clearInterval(this.timer);
        this.setState({
            isTimerStopped: true,
        });
        localStorage.setItem('timer_stop', JSON.stringify(true)); 
      }
      const correctChoice = questionItem.right_choice;
      const isCorrect = (correctChoice === selectedChoice) ? 1 : 0;
      const resultText = (isCorrect === 1) ? messages.CORRECT : messages.INCORRECT;
      const textColor = (isCorrect === 1) ? 'card-header text_success' : 'card-header text_failure';
      this.setState({
        result_block: 'card show_block', isAnswered: true, result: resultText, textColor: textColor,
      });
      // Now answered → re-publish context with the item embedded (grounds the sidebar/typed ask).
      this.dispatchAiContext(questionItem, { selectedChoice, showAnswer: true });
      if (!validated) {
        const data = { token, idname, quiz_id, question_id: all_question_id[offset], answer: isCorrect, selectedChoice };
        FD.callAPI(`${App_data.backend_api}/cfa_2025_quizes/answerQuiz`, data).then(resp => {
          if (resp.success) {
            const questionsData = { token, idname, question_id: all_question_id[offset], right_answer: isCorrect, time_done: 0, };
            FD.callAPI(
              `${App_data.backend_api}/question_bank_2025/saveStats`,
              questionsData
            );
          }
          this.setState({ isValidToken: resp.success, validated: true });
        });
      }
    }
  };

  navigateQuestion = (offset) => {
    if (this.timer) clearInterval(this.timer);
    this.setState({
      display_loader: 'show_block', validated: false, isAnswered: false, selectedChoice: '', 
      result_block: 'card hide_block', report_block: 'card hide_block',
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark', bookmarkColor: '',
      save_text: `${language.LC().SAVE_QUESTION}`, offset: offset,
      previ_block: offset === 0 ? 'card hide_block' : '',
      next_block: offset === this.state.all_question_id.length - 1 ? 'card hide_block' : '',
      count_end_message: '', 
    }, () => {
      if (document.getElementById('comment')) document.getElementById('comment').value = '';
      if (this.state.all_question_id[offset]) {
        this.fetchQuestionDetails(this.state.all_question_id[offset]);
      } else {
        this.setState({display_loader: 'hide_block', already_answered_status: messages.QUESTION_NOT_FOUND});
      }
    });
  };

  _getNext = () => {
    if (this.state.offset < this.state.all_question_id.length - 1) this.navigateQuestion(this.state.offset + 1);
  };
  _getPrevious = () => {
    if (this.state.offset > 0) this.navigateQuestion(this.state.offset - 1);
  };

  _saveQuestion = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
    };
    const apiEndpoint = this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark'
      ? '/question_bank_2025/unsaveQuestion'
      : '/question_bank_2025/saveQuestion';

    FD.callAPI(`${App_data.backend_api}${apiEndpoint}`, data).then(resp => {
      if (resp.success) {
        const isUnsaveAction = apiEndpoint.includes('unsave');
        this.setState({
          isValidToken: true,
          bookmarkCSS: isUnsaveAction ? 'fa fa-bookmark-o mark-action-btn-bookmark' : 'fa fa-bookmark mark-action-btn-bookmark',
          bookmarkColor: isUnsaveAction ? '' : 'rgb(54, 141, 84)',
          save_text: isUnsaveAction ? `${language.LC().SAVE_QUESTION}` : `${language.LC().Question_Saved}`,
        });
      } else {
        this.setState({ isValidToken: false });
      }
    });
  };

  _reportQuestion = (item, e) => {
    const comment = document.getElementById('comment') ? document.getElementById('comment').value : '';
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      comment: comment,
    };
    FD.callAPI(`${App_data.backend_api}/question_bank_2025/reportQuestion`, data).then(resp => {
      if (resp.success) {
        this.setState({ isValidToken: true, successAlert: true });
        if (document.getElementById('comment')) document.getElementById('comment').value = '';
      } else {
        this.setState({ isValidToken: false });
      }
    });
  };

  onClose = e => {
    this.setState({
      report_block: 'card hide_block',
      successAlert: false,
    });
  };

  _displayReportForm = (item, e) => {
    this.setState({ report_block: 'card show_block' });
  };

  _hideReportForm = (item, e) => {
    this.setState({ report_block: 'card hide_block' });
  };

  getToggleComment = () => {
    this.setState(prevState => ({
      isCommentVisible: !prevState.isCommentVisible
    }));
  };

  getToggleFlash = () => {
    this.setState(prevState => ({
      isFlashCardVisible: !prevState.isFlashCardVisible
    }));
  };

    _saveFlashCard = (item, e) => {
      const flashCardInput = document.getElementById('flash_card');
      if (!flashCardInput || flashCardInput.value === '') {
        return;
      }
      const { token, idname, quiz_id } = this.state;
      const flash_card = flashCardInput.value;
      const data = {
        token: token,
        idname: idname,
        question_id: item.id,
        flash_card: flash_card,
        quiz_id: quiz_id,
      };
      FD.callAPI(`${App_data.backend_api}/question_bank_2025/saveFlashCard`, data).then(resp => {
        if (resp.success) {
          this.setState({ isValidToken: true });
          flashCardInput.value = '';
          this.fetchFlashCards(item.id);
        } else {
          this.setState({ isValidToken: false });
        }
      });
    };
    
    fetchFlashCards = (questionId) => {
        var params = {
            token: this.state.token,
            idname: this.state.idname,
            question_id: questionId,
            quiz_id: this.state.quiz_id,
          };
          FD.callAPI(`${App_data.backend_api}/question_bank_2025/getFlashCards`, params).then(
            response => {
              var flash_cards_jsx = '';
              if (response.success) {
                this.setState({ isValidToken: true });
                if (response.flash_cards && response.flash_cards.length > 0) {
                  this.setState({ flash_form: 'col-sm-12 hide_block' });
                  flash_cards_jsx = response.flash_cards.map(fc_item => (
                    <li key={fc_item.id}>
                      <div className=''>
                        <ul className='icon_list'>
                          <li>
                            <a className='pointer_class' onClick={this._editFlash.bind(this, fc_item)}>
                              <i className='fa fa-pencil' />
                            </a>
                          </li>
                          <li>
                            <a
                              className='pointer_class'
                              onClick={this._deleteFlash.bind(this, fc_item)}
                            >
                              <i className='fa fa-close' />
                            </a>
                          </li>
                        </ul>
                        <div className={this.state.flash_class}>
                          <h4 />
                          <p>{fc_item.flash_card}</p>
                        </div>
                      </div>
                    </li>
                  ));
                } else {
                  this.setState({ flash_form: 'col-sm-12 display_block' });
                  flash_cards_jsx = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                }
                this.setState({ flash_data: flash_cards_jsx });
              } else {
                flash_cards_jsx = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                this.setState({ isValidToken: false, flash_data: flash_cards_jsx, flash_form: 'col-sm-12 display_block' });
              }
            },
          );
    }


    _editFlash = (item, e) => {
      this.setState({ flash_form: 'col-sm-12 display_block' });
      const flashCardInput = document.getElementById('flash_card');
      if (flashCardInput) {
        flashCardInput.value = item.flash_card;
      }
    };

    _deleteFlash = (item, e) => {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        flash_card: item,
      };
      FD.callAPI(`${App_data.backend_api}/question_bank_2025/deleteFlashCard`, data).then(resp => {
        if (resp.success) {
          this.setState({ isValidToken: true, flash_form: 'col-sm-12 display_block' });
          const flashCardInput = document.getElementById('flash_card');
          if (flashCardInput) flashCardInput.value = '';
          this.setState({ flash_data: <p>{language.LC().NO_FLASHCARD_FOUND}</p> });
        } else {
          this.setState({ isValidToken: false });
        }
      });
    };

  _timer_funct = () => {
    if (!this.hasTimerFeatureEnabled()) return;
    if (this.state.isAnswered) return; // If question validated, do nothing.
    // If time is up (message shown), button should be disabled, but this is a safeguard.
    if (this.state.count <= 0 && !!this.state.count_end_message) return;

    const newTimerStopState = !this.state.isTimerStopped; 
    localStorage.setItem('timer_stop', JSON.stringify(newTimerStopState));
    this.setState({
      isTimerStopped: newTimerStopState,
    });

    if (newTimerStopState) { 
      clearInterval(this.timer);
    } else { 
      // Only start if time is left AND no answer has been selected yet.
      if (this.state.count > 0 && !this.state.selectedChoice) {
        clearInterval(this.timer); 
        this.timer = setInterval(this.reverseTimerHandler.bind(this), 1000);
      } else {
        // If trying to "Play" but an answer is already selected, or time is 0, revert to stopped state.
        this.setState({ 
          isTimerStopped: true, 
        });
        localStorage.setItem('timer_stop', JSON.stringify(true));
        if(this.timer) clearInterval(this.timer);
      }
    }
  };

  _getSummary = () => {
    const url = `${nextAwareRoute(AppRoutes.CFA1_2025_QUIZ_BEFORE_START).split('(')[0]}/${this.state.quiz_id}/abondon`;
    window.location.href = url;
  };

  render() {
    let questions = this.state.display_question || {};
    let count_temp_var = this.state.count;
    let display_time = '0 sec';
    const isTimeUp = count_temp_var <= 0;

    if (typeof count_temp_var === 'number' && count_temp_var >= 0) {
        if (count_temp_var < 60) {
            display_time = `${count_temp_var} sec`;
        } else {
            const minutes = Math.floor(count_temp_var / 60);
            const seconds = count_temp_var % 60;
            display_time = `${minutes} min ${seconds} sec`;
        }
    }
    
    const isValidateDisabled = this.state.isAnswered || !this.state.selectedChoice;
    const isTimerButtonDisabled = 
        !this.hasTimerFeatureEnabled() ||
        isTimeUp || 
        this.state.isAnswered;

    const timerButtonClass = this.state.isTimerStopped ? 'pause_btn icon-control-play' : 'pause_btn icon-control-pause';

    let dataContent = null;
    if (this.state.all_question_id.length > 0 && this.state.offset < this.state.all_question_id.length && Object.keys(questions).length > 0) {
      dataContent = (
        <div>
          <div className='card margin_bottom_40'>
            <div className='card-header'>
              <img src={App_data.frontend_url + '/img/question_bank/question_icon_blue.svg'} className='margin_right_20' width='30' alt=''/>
              {language.LC().Q} {parseInt(this.state.offset) + 1}{' '}
              {renderHTMLContent(questions.name_2025 || '', "span", "", { contentEditable: "false" })}
              <div className='float-right text-right'>
                <i className={'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block} onClick={this._getPrevious} role="button" tabIndex={0} onKeyPress={this._getPrevious} aria-label="Previous question" />
                <i className={'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block} onClick={this._getNext} role="button" tabIndex={0} onKeyPress={this._getNext} aria-label="Next question" />
              </div>
            </div>
            <div className='card-block'>
              <div className='row'>
                <div className='col-sm-9'>
                  <ViewQuestion
                    {...questions}
                    setAnswer={this.handleAnswerSelect}
                    showAnswer={this.state.isAnswered} 
                    correctChoice={this.state.correctChoice}
                    selectedChoice={this.state.selectedChoice} >
                    <Col md={12} className='mt-2'>
                      <Row className='align-items-center'>
                        <ValidateSaveReportIcon
                          isQue={true}
                          clicked={isValidateDisabled} 
                          _getResult={() => this.handleResultEvaluation(questions)}
                          _saveQuestion={() => this._saveQuestion(questions)}
                          _displayReportForm={() => this._displayReportForm(questions)}
                          all_questions={questions}
                          save_text={this.state.save_text}
                          bookmarkCSS={this.state.bookmarkCSS}
                          bookmarkColor={this.state.bookmarkColor}
                          showResult={this.state.isAnswered || !this.state.selectedChoice} />
                      </Row>
                    </Col>
                  </ViewQuestion>
                </div>
                <div className='col-sm-3'>
                  {this.hasTimerFeatureEnabled() && (
                    <div> 
                        <div className='timer_outer'>
                            <i className='fa fa-clock-o' />
                            {!isTimeUp && <span className='timer_box'>{display_time}</span>}
                        </div>
                        {!isTimeUp && (
                            <span className={'quiz_timer_btn ' + this.state.timer_display}>
                            <button type="button" aria-label={this.state.isTimerStopped ? 'Resume timer' : 'Pause timer'} className={timerButtonClass} onClick={this._timer_funct} disabled={isTimerButtonDisabled} />
                            </span>
                        )}
                        {isTimeUp && (
                            <p className='text-danger'>
                            {renderHTMLContent(language.LC().TIME_UP, "div", "", { contentEditable: "false" })}
                            </p>
                        )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {this.state.isAnswered && this.state.result_block === 'card show_block' && (
              <div className={`${this.state.result_block} font-lusitana font-16px`}>
                  <div className={this.state.textColor}>{this.state.result}</div>
                  <div className='card-block'>
                      {isAiTutorAvailable() && (
                          <div className='mb-2'>
                              <CustomButton onClick={this.explainMyAnswer} btnColor='ai' style={AI_TRIGGER_BTN_STYLE} className='ap-ai-launcher'>✦ Explain my answer</CustomButton>
                          </div>
                      )}
                      {renderHTMLContent(questions.answer || '', "div", "", { contentEditable: "false" })}
                  </div>
              </div>
          )}
          <div className={this.state.report_block}>
              <div className='card-header'>
                {messages.REPORT}
              </div>
              {!this.state.successAlert ? (
                <div className='card-block'>
                  <div className='row'>
                    <div className='col-sm-12'>
                      <label className='form-control-label' htmlFor='textarea-input'>
                        <strong>{messages.COMMENT}</strong>
                      </label>
                    </div>
                    <div className='col-sm-12 margin_bottom_10'>
                      <textarea
                        id='comment'
                        name='comment'
                        rows='6'
                        className='form-control'
                        placeholder='Content..'
                      />
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-sm-12'>
                      <button
                        type='button'
                        className='btn btn-primary active pointer_class'
                        onClick={() => this._reportQuestion(questions)}
                      >
                        {messages.REPORT}
                      </button>
                      <button
                        type='button'
                        className='btn btn-danger active pointer_class margin_left_10'
                        onClick={() => this._hideReportForm(questions)}
                      >
                        {messages.CANCEL}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className='card-block'>
                  <div className='row'>
                    <div className='col-sm-12 report-Success-card'>
                      <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                      <label className='form-control-label' htmlFor='textarea-input'>
                        <strong>{messages.REPORT_SEND_SUCCESS_MESSAGE}</strong>
                      </label>
                      <button
                        type='button'
                        className='btn btn-primary active pointer_class  min-vw-120'
                        onClick={this.onClose}
                      >
                        {' '}
                        {messages.CLOSE}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
        </div>
      );
    } else if (this.state.display_loader === 'hide_block') {
      dataContent = <div>{messages.QUIZ_FINISHED}</div>;
    }

    return (
      <div>
        <div className='animated fadeIn'>
          <div className='row'>
            <div className='col-sm-8 margin_bottom_20'>
              <h1 className='section_head'> {language.LC().QUIZ_ID} : {this.state.quiz_id} </h1>
              <p className='text-danger' role={this.state.already_answered_status ? 'status' : undefined}>{this.state.already_answered_status}</p>
            </div>
            <div className='col-sm-4 margin_bottom_20 text-sm-right'>
              <button className='btn btn-primary pointer_class' onClick={this._getSummary}> {' '} {language.LC().BACK_TO_SUMMARY}{' '} </button>
            </div>
          </div>
          <div className='row'> <div className='col-sm-12 col-md-12 margin_bottom_20'>{dataContent}</div> </div>
        </div>
        <div className={'loader_box ' + this.state.display_loader}>
          <div className='sk-circle'> {[...Array(12)].map((_, i) => ( <div key={i} className={`sk-circle${i + 1} sk-child`} /> ))} </div>
        </div>
      </div>
    );
  }
}

// TooltipItem class remains the same
class TooltipItem extends React.Component {
    constructor(props) {
      super(props);
      this.toggle = this.toggle.bind(this);
      this.state = { tooltipOpen: false };
    }
    toggle() { this.setState({ tooltipOpen: !this.state.tooltipOpen }); }
    render() {
      return (
        <span>
          <img src={App_data.frontend_url + '/img/dashboard/info_icon.svg'} id={'Tooltip-' + this.props.id} width='18' alt='' style={{ marginLeft: '4px' }} />
          <Tooltip placement={this.props.place_tip} isOpen={this.state.tooltipOpen} target={'Tooltip-' + this.props.id} toggle={this.toggle}>
            <p className='tooltip_text'>{this.props.content}</p>
          </Tooltip>
        </span>
      );
    }
  }
export default BeginQuiz;


// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Quizzes/BeginQuiz.js